import { render } from "./AccordionElement.vue?vue&type=template&id=4182bc5a"
import script from "./AccordionElement.vue?vue&type=script&lang=js"
export * from "./AccordionElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__